import { defineStore } from 'pinia'
import { ref } from 'vue'

// Define interface for philosopher data
interface Philosopher {
  name: string;
  alignment: string;
}

export const usePhilosopherStore = defineStore('philosopher', () => {
  // Default philosophers with alignments
  const leftPhilosopher = ref<Philosopher>({
    name: 'Adam Smith',
    alignment: 'Classical Liberalism'
  })
  
  const rightPhilosopher = ref<Philosopher>({
    name: 'Karl Marx',
    alignment: 'Socialism'
  })

  // Update the page title based on the current philosophers
  function updatePageTitle() {
    document.title = `OuiBeef: ${leftPhilosopher.value.name} vs. ${rightPhilosopher.value.name}`
  }

  // Set philosophers and update the page title
  function setPhilosophers(left: Philosopher, right: Philosopher) {
    leftPhilosopher.value = left
    rightPhilosopher.value = right
    updatePageTitle()
  }

  // Initialize the title
  updatePageTitle()

  return {
    leftPhilosopher,
    rightPhilosopher,
    setPhilosophers,
    updatePageTitle
  }
})